"use client";

import type * as React from "react";
import { Skeleton } from "@/components/ui/skeleton";

interface ModalSkeletonProps {
  rows?: number;
}

export const ModalSkeleton: React.FC<ModalSkeletonProps> = ({ rows = 3 }) => {
  return (
    <div className="space-y-3">
      {Array.from({ length: rows }).map((_, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton rows have no natural key
        <Skeleton key={i} className="h-8 w-full rounded-sm" />
      ))}
    </div>
  );
};
